import Vue from 'vue'
import VueRouter from 'vue-router'
import PcIndex from '../views/pc_index'
import detail from '../views/detail'
// import chats from '../views/chats'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '',
  //   redirect: '/discovery'
  // },  
  //path设置如 /home 服务器找不到文件，需要配置伪静态
  {
    path: '/index',
    name: 'index',
    component: PcIndex
  },
  {
    path: '/detail/:id(\\d+)',
    name: 'detail',
    component: detail
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  base: '/universities'
  // base: '/'
})

const defaultTitle = '嘉兴·全国合作高校联盟'
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? to.meta.title : defaultTitle
  next()
})

export default router
